import { gql } from "@apollo/client";

export const GET_ATTENDANCE_BY_CLASS = gql`
  query GetAttendanceByClass($classId: ID, $attendanceDate: String) {
    getAttendanceByClass(class_id: $classId, attendance_date: $attendanceDate) {
      _id
      attendance_date
      attendance_status
      reason
      class_attended {
        _id
        is_drop_out
      }
      student_id {
        _id
        student_id
        full_name_kh
        full_name_latin
        gender
      }
    }
  }
`;

export const DELETE_ATTENDANCE_STATUS = gql`
  mutation DeleteAttendance($id: ID) {
    deleteAttendance(_id: $id) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const UPDATE_ATTENDANCE = gql`
  mutation UpdateAttendance($id: ID, $input: AttendanceInput) {
    updateAttendance(_id: $id, input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const CREATE_ATTENDANCE_BY_DAY = gql`
  mutation CreateClassAttenceByDay($classId: ID, $attendanceDate: String) {
    createClassAttenceByDay(
      class_id: $classId
      attendance_date: $attendanceDate
    ) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const GET_ALL_STUDENT_ATTENDANCE_BY_CLASS = gql`
  query GetAllStudentAttendanceByClass(
    $classId: ID
    $from: DateTime
    $to: DateTime
  ) {
    getAllStudentAttendanceByClass(class_id: $classId, from: $from, to: $to) {
      student {
        _id
        student_id
        full_name_kh
        full_name_latin
      }
      days {
        attendance_status
        reason
      }
      class_attended_id
      totalAbsence
      totalPercentage
      totalPresence
    }
  }
`;

export const GET_STUDENT_ATTENDENCE_BY_STUDENT_ID = gql`
  query GetStudentAttendanceByStudentId(
    $stuId: ID
    $from: DateTime
    $to: DateTime
  ) {
    getStudentAttendanceByStudentId(stu_id: $stuId, from: $from, to: $to) {
      days {
        reason
        attendance_status
      }
      totalPresence
      totalAbsence
      totalPercentage
    }
  }
`;

export const IMPORT_STUDENT_ATTENDANCE_FROM_CSV_FILE = gql`
  mutation ImportStudentAttendanceFromCSVFile(
    $attendanceDate: DateTime
    $input: [ImportStudentAttendanceFromCSVInput]
    $classId: ID
  ) {
    importStudentAttendanceFromCSVFile(
      attendance_date: $attendanceDate
      input: $input
      class_id: $classId
    ) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const DELETE_ALL_ATTENDANCE = gql`
mutation DeleteAllAttendance($classId: ID, $attendanceDate: DateTime) {
  deleteAllAttendance(class_id: $classId, attendance_date: $attendanceDate) {
    is_success
    message {
      message_en
      message_kh
    }
  }
}`
